import React, { Ref, useImperativeHandle, useState } from "react";
import ConfirmationDialog, { ConfirmationDialogProps } from "./ConfirmationDialog";

const HIDE_CONFIRMATION_DIALOG: ConfirmationDialogProps = {
  onConfirm: (): void => {},
  onCancel: (): void => {},
  open: false,
};

export type ConfirmationDialogHolderRef = {
  show: (confirmationDialog: ConfirmationDialogProps) => void;
  hide: () => void;
  isOpen: () => boolean;
  cancel: () => void;
};

function ErrorMessage(props: {}, ref: Ref<ConfirmationDialogHolderRef> | undefined) {
  const [confirmationDialog, setConfirmationDialog] = useState(HIDE_CONFIRMATION_DIALOG);

  useImperativeHandle(ref, () => ({
    show: (confirmationDialogProps: ConfirmationDialogProps): void => {
      setConfirmationDialog(confirmationDialogProps);
    },
    hide: () => {
      setConfirmationDialog(HIDE_CONFIRMATION_DIALOG);
    },
    isOpen: () => confirmationDialog.open,
    cancel: () => confirmationDialog.onCancel(),
  }));

  return <ConfirmationDialog {...confirmationDialog} />;
}

export default React.forwardRef(ErrorMessage);
